module.exports = __webpack_public_path__ + "static/media/template_tickets.88e0d746.csv";